import { JSX } from 'react';
import { CardSuit } from '@bg-shared';
import { AllSuitsIcon, ClubsIcon, DiamondsIcon, HeartsIcon, SpadesIcon } from '../Icons';

interface IProps {
    suit: CardSuit;
    className?: string;
    dataQa?: string;
}

const CardSuitList = {
    [CardSuit.CLUBS]: ClubsIcon,
    [CardSuit.DIAMONDS]: DiamondsIcon,
    [CardSuit.HEARTS]: HeartsIcon,
    [CardSuit.SPADES]: SpadesIcon,
    [CardSuit.ALL]: AllSuitsIcon,
};

export const CardSuitIcon = (props: IProps): JSX.Element => {
    const Icon = CardSuitList[props.suit];

    return <Icon className={props.className} data-qa={props.dataQa} />;
};
